import { render, staticRenderFns } from "./Error500.vue?vue&type=template&id=504739a4&scoped=true"
import script from "./Error500.vue?vue&type=script&lang=js"
export * from "./Error500.vue?vue&type=script&lang=js"
import style0 from "./Error500.vue?vue&type=style&index=0&id=504739a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504739a4",
  null
  
)

export default component.exports